import React from 'react'

import './Testimonial.scss';
const Testimonial = () => {
  return (
    <div></div>
  )
}

export default Testimonial